module.exports = __webpack_public_path__ + "img/denza.b4922d59.jpg";